import { render } from "./ActualProposalExamplesModal.vue?vue&type=template&id=aa923c5e"
import script from "./ActualProposalExamplesModal.vue?vue&type=script&lang=js"
export * from "./ActualProposalExamplesModal.vue?vue&type=script&lang=js"

import "./ActualProposalExamplesModal.vue?vue&type=style&index=0&id=aa923c5e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__